import { ORDER_TYPES, PROVIDERS } from '../constants.js'

export const getWidgetUrl = async (
  { type = ORDER_TYPES.buy, ...order } = {},
  { providerManager, serverClient } = {}
) => {
  if (type !== ORDER_TYPES.buy) {
    throw new Error('Only `buy` orders are accepted')
  }

  const { redirectUrl, providerId } = await providerManager.createOrder(order, { serverClient })
  const response = await serverClient.updateOrder(order.orderId, {
    providerId,
    provider: PROVIDERS.paypal,
  })

  if (!response?.success) {
    throw new Error('Failed to update order')
  }

  return redirectUrl
}
